import * as DropdownMenuPrimitive from "@radix-ui/react-dropdown-menu";
import React from "react";
import { breakpointClasses, cn, splitBreakpointProps } from "@/lib/utils";
import type { DropdownMenuTriggerProps } from "../types";

function DropdownMenuTrigger({
  className,
  ...props
}: DropdownMenuTriggerProps) {
  const { bp, native } = splitBreakpointProps(props);
  const classes = breakpointClasses(bp);

  return (
    <DropdownMenuPrimitive.Trigger
      data-slot="dropdown-menu-trigger"
      className={cn(className, classes)}
      {...native}
    />
  );
}

DropdownMenuTrigger.displayName = "DropdownMenu.Trigger";

export default DropdownMenuTrigger;
